import { useState, useEffect } from 'react';
import axios from 'axios';

// Cached at module scope so the three link-generating pages (Attendance,
// Evaluation, ProfileLinks) share one network call instead of three.
let cachedPromise = null;

const fetchBaseUrl = () => {
  if (!cachedPromise) {
    cachedPromise = axios
      .get('/api/public-config')
      .then((res) => res.data.publicLinksBaseUrl || '')
      .catch(() => '');
  }
  return cachedPromise;
};

// Returns the admin-configured base URL for trainee-facing links (attendance,
// evaluation, profile update) if PUBLIC_LINKS_BASE_URL is set in Railway,
// otherwise falls back to window.location.origin (the main portal domain).
const usePublicLinksBaseUrl = () => {
  const [baseUrl, setBaseUrl] = useState(window.location.origin);

  useEffect(() => {
    let cancelled = false;
    fetchBaseUrl().then((url) => {
      if (!cancelled && url) setBaseUrl(url);
    });
    return () => { cancelled = true; };
  }, []);

  return baseUrl;
};

export default usePublicLinksBaseUrl;
